import { render, staticRenderFns } from "./QTop5Leaderboards.vue?vue&type=template&id=7a607816&"
import script from "./QTop5Leaderboards.vue?vue&type=script&lang=js&"
export * from "./QTop5Leaderboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports